import axios from "axios";

export default function ProductionitemShowService(id) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/production_item/" + id,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
